import React from 'react';
import { cn } from './cn';

/** Small solid proportional circle; its containing control supplies the accessible label. */
export default function PieIndicator({ segments, className }) {
  const positive = segments.filter(segment => segment.value > 0);
  const total = positive.reduce((sum, segment) => sum + segment.value, 0);
  let offset = 0;
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" className={cn('h-3 w-3 shrink-0', className)}>
      {positive.map(segment => {
        const percent = segment.value / total * 100;
        const start = offset;
        offset += percent;
        return <circle key={segment.id} cx="10" cy="10" r="5" fill="none"
          stroke={segment.color} strokeWidth="10" pathLength="100"
          strokeDasharray={`${percent} ${100 - percent}`} strokeDashoffset={-start}
          transform="rotate(-90 10 10)" />;
      })}
    </svg>
  );
}
